export default __webpack_public_path__ + "static/media/What we do-eachpage-Enterprise Software_Development.35fe4683.png";